var _circle, _circle2, _circle3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeat4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 209,
    viewBox: "0 0 327 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 59,
    r: 100,
    transform: "rotate(-90 100 59)",
    fill: "url(#paint0_linear_23_185)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 59,
    r: 130,
    transform: "rotate(90 224 59)",
    fill: "url(#paint1_linear_23_185)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 338,
    cy: 59,
    r: 150,
    transform: "rotate(90 338 59)",
    fill: "url(#paint2_linear_23_185)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23_185",
    x1: 200,
    y1: 59,
    x2: 0,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E2E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9896FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23_185",
    x1: 354,
    y1: 59,
    x2: 94,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BDBBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9896FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_23_185",
    x1: 188,
    y1: 59,
    x2: 488,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E2E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9896FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeat4);
export default __webpack_public_path__ + "static/media/feat-4.cbe7ede8c807cf69afcba265c7fdc637.svg";
export { ForwardRef as ReactComponent };